import { render, staticRenderFns } from "./inputLabel.vue?vue&type=template&id=48d93707&scoped=true"
import script from "./inputLabel.vue?vue&type=script&lang=js"
export * from "./inputLabel.vue?vue&type=script&lang=js"
import style0 from "./inputLabel.vue?vue&type=style&index=0&id=48d93707&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d93707",
  null
  
)

export default component.exports